import { rgba } from 'polished';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type Props = {
  color: string;
};

export const UserWidget = styled.div<Props>`
  float: right;
  background-color: ${({ color }) => rgba(color, 0.1)};
  border-radius: 20px;
  display: flex;
  align-items: center;
  height: 40px;
`;

export const UserName = styled.span`
  margin: 0 12px 0 18px;
  font-weight: 500;
`;

export const Name = styled.div`
  height: 15px;
  font-size: 12px;
  line-height: 1.25;
  color: ${COLOR.OUTER_SPACE};
`;

export const CompanyName = styled.div<Props>`
  height: 10px;
  font-size: 0.5rem;
  line-height: 1.25;
  color: ${({ color }) => color};
  text-transform: uppercase;
`;
